import React, {useState} from "react"
import { Row, Col } from "react-bootstrap"
import EachSong from "./eachsong"
import { graphql, StaticQuery , Link } from "gatsby"
import {GoTriangleRight} from "react-icons/go"
import "../../Styles/musicsecs.scss"
export default function MusicVideos() {
  const [ btnhover1 , setbtnhover1] = useState(false)
  return (
    <div>
      <Row>
      <Col md="12" className="music-sec-titles">
        <h1>MUSIC VIDEOS</h1>
        <Link to="./musicvideos">
        <span 
        onMouseEnter={() => {
          setbtnhover1(true)
      }}
      onMouseLeave={() => {
        setbtnhover1(false)
      }}
     className={btnhover1 ? "badge-hover badge" :"badge" } > 
          <ul>
            <li>
              <small>
                <GoTriangleRight />
              </small>
            </li>
            <li>
            <small>
                Load more
              </small>
            </li>
          </ul>
          <small>

          </small>
        </span></Link>
        <div className="div1">
          <div className="div2"></div>
        </div>
      </Col></Row>
        <div className="scroll-container">
      <StaticQuery
        query={topmusic}
        render={data => {
          return (
           
      <Row >
              {data.allMarkdownRemark.edges.map(({ node }) => (
                <Col xs={6} sm={4} md={3} lg={2}>
                  <EachSong
                    key={node.id}
                    title={node.frontmatter.title}
                    artist={node.frontmatter.artist}
                    date={node.frontmatter.date}
                    slug={node.fields.slug}
                    fluid={node.frontmatter.image.childImageSharp.fluid}
                  />
               </Col>
              ))}
            </Row>
          )
        }}
      /></div>
    </div>
  )
}

const topmusic = graphql`
  query {
    allMarkdownRemark(
      sort: { fields: [frontmatter___rate], order: DESC }
      limit: 6
      filter: { frontmatter: { cat: { eq: "music" } } }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            date
            rate
            image {
              childImageSharp {
                fluid(maxWidth: 900) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            artist
          }

          fields {
            slug
          }
        }
      }
    }
  }
`
